import React, { ReactNode } from "react"
import clsx from "clsx"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./Typography.module.css"

export type { LabelProps } from "./Label"
export { Label } from "./Label"
export { P } from "./P"

export type { TitleProps } from "./Title"
export type { PProps } from "./P"
export { Title } from "./Title"

export const Span = ({
  children,
  $color = "primary",
  $fontWeight = "inherit",
  className = "",
  style = {},
  ...rest
}: BaseStyles & {
  children: ReactNode
  className?: string
  style?: React.CSSProperties
}) => {
  const generatedStyles = generateStylesFromProps({ ...rest, $color, $fontWeight })

  const spanStyles = {
    ...generatedStyles,
    ...style,
  }

  return (
    <span className={clsx(styles.span, className)} style={spanStyles}>
      {children}
    </span>
  )
}

const createHeadingComponent = (tag: string, styleClass: string, displayName: string) => {
  const Heading = ({
    children,
    className = "",
    style = {},
    ...rest
  }: BaseStyles & {
    children: ReactNode
    className?: string
    style?: React.CSSProperties
  }) => {
    const generatedStyles = generateStylesFromProps(rest)

    const headingClasses = clsx(styles[styleClass], className)

    const headingStyles = {
      margin: 0,
      ...generatedStyles,
      ...style,
    }

    return React.createElement(tag, { className: headingClasses, style: headingStyles }, children)
  }
  Heading.displayName = displayName
  return Heading
}

export const H1 = createHeadingComponent("h1", "h1", "H1")
export const H2 = createHeadingComponent("h2", "h2", "H2")
export const H3 = createHeadingComponent("h3", "h3", "H3")
export const H4 = createHeadingComponent("h4", "h4", "H4")

export const LabelH1 = createHeadingComponent("label", "h1", "LabelH1")
export const LabelH2 = createHeadingComponent("label", "h2", "LabelH2")
export const LabelH3 = createHeadingComponent("label", "h3", "LabelH3")
export const LabelH4 = createHeadingComponent("label", "h4", "LabelH4")
